const API_BASE = process.env.REACT_APP_API_BASE;

if (!API_BASE) {
  console.error("[chat.js] Missing REACT_APP_API_BASE");
  throw new Error("API_BASE is not defined. Did you set REACT_APP_API_BASE in .env?");
}

/**
 * Create or get a conversation between client and landlord
 */
export async function createOrGetConversation(landlordUserId, roomId) {
  const token = localStorage.getItem("token");

  const res = await fetch(`${API_BASE}/api/Chat/conversations/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token 
    },
    body: JSON.stringify({
      landlordUserId,
      roomId
    })
  });

  if (!res.ok) throw new Error("Failed to create/get conversation");

  return res.json();
}

/**
 * Load paginated messages
 */
export async function getMessages(conversationId, pageNumber = 1, pageSize = 50) {
  const url = `${API_BASE}/api/Chat/conversations/${conversationId}/messages?pageNumber=${pageNumber}&pageSize=${pageSize}`;

  const token = localStorage.getItem("token");

    const res = await fetch(url, {
    headers: {
        "Authorization": "Bearer " + token
    }
    });

  if (!res.ok) {
    console.error("Failed to fetch messages:", await res.text());
    throw new Error("Failed to fetch messages");
  }

  return res.json(); // { items, totalCount }
}

export async function getConversations() {
  const token = localStorage.getItem("token");

  const res = await fetch(`${API_BASE}/api/Chat/conversations`, {
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });

  if (!res.ok) throw new Error("Failed to fetch conversations");
  return res.json();
}

